import React from "react";
import PropTypes from "prop-types";
import VmoResponsivePie from "../Nivo/VmoResponsivePie";
const defaultLegends = {
  anchor: "right",
  direction: "column",
  translateX: -80,
  translateY: 0,
  itemsSpacing: 7,
  itemWidth: 101,
  itemHeight: 19,
  itemDirection: "left-to-right",
};

const VmoPie = ({
  data = [],
  CenteredMetric = () => null,
  colors = { scheme: "nivo" },
  margin = { top: 5, right: 80, bottom: 80, left: 80 },
  full = true,
  enableArcLinkLabels = true,
  enableArcLabels = true,
  showLegends = true,
  legends: legendsObj = {},
  arcLinkLabelsSkipAngle = 10
}) => {
  const legends = { ...defaultLegends, ...legendsObj };

  if (full) {
    return (
      <VmoResponsivePie
        data={data}
        margin={margin}
        startAngle={-45}
        innerRadius={0.5}
        padAngle={2}
        cornerRadius={3}
        borderWidth={1}
        colors={colors}
        activeOuterRadiusOffset={0}
        sliceLabel={({ value }) => `${value}`}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        enableArcLinkLabels={enableArcLinkLabels}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextOffset={3}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsStraightLength={10}
        arcLinkLabelsDiagonalLength={5}
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        enableArcLabels={enableArcLabels}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: "color",
          modifiers: [["darker", 2]],
        }}
        animate={true}
        tooltip={(e) => {
          const {
            id,
            value,
            data: { percentage },
          } = e.datum;
          return (
            <strong
              style={{
                backgroundColor: "white",
                padding: "3px 6px 3px 6px",
                borderRadius: "2px",
              }}
            >
              {id} : {value} {percentage ? `(${percentage}%)` : ""}
            </strong>
          );
        }}
        motionStiffness={90}
        motionDamping={15}
        legends={[
          ...(showLegends
            ? [
                {
                  anchor: legends.anchor,
                  direction: legends.direction,
                  justify: false,
                  translateX: legends.translateX,
                  translateY: legends.translateY,
                  itemsSpacing: legends.itemsSpacing,
                  itemWidth: legends.itemWidth,
                  itemHeight: legends.itemHeight,
                  itemTextColor: "#999",
                  itemDirection: legends.itemDirection,
                  itemOpacity: 1,
                  symbolSize: 13,
                  symbolShape: "circle",
                  effects: [
                    {
                      on: "hover",
                      style: {
                        itemTextColor: "#000",
                      },
                    },
                  ],
                },
              ]
            : []),
        ]}
      />
    );
  }
  return (
    <VmoResponsivePie
      data={data}
      margin={margin}
      startAngle={-90}
      endAngle={90}
      innerRadius={0.5}
      padAngle={1}
      cornerRadius={5}
      colors={colors}
      borderWidth={1}
      activeOuterRadiusOffset={0}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      enableArcLinkLabels={enableArcLinkLabels}
      arcLinkLabelsSkipAngle={arcLinkLabelsSkipAngle}
      arcLinkLabelsTextOffset={3}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsStraightLength={10}
      arcLinkLabelsDiagonalLength={5}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      enableArcLabels={enableArcLabels}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 2]],
      }}
      layers={["arcs", "arcLinkLabels", "arcLabels", "legends", CenteredMetric]}
      tooltip={(e) => {
        const {
          id,
          value,
          data: { percentage },
        } = e.datum;
        return (
          <strong
            style={{
              backgroundColor: "white",
              padding: "3px 6px 3px 6px",
              borderRadius: "2px",
            }}
          >
            {id} : {value} {percentage ? `(${percentage}%)` : ""}
          </strong>
        );
      }}
      animate={true}
      legends={[
        ...(showLegends
          ? [
              {
                anchor: legends.anchor,
                direction: legends.direction,
                justify: false,
                translateX: legends.translateX,
                translateY: legends.translateY,
                itemsSpacing: legends.itemsSpacing,
                itemWidth: legends.itemWidth,
                itemHeight: legends.itemHeight,
                itemTextColor: "#999",
                itemDirection: legends.itemDirection,
                itemOpacity: 1,
                symbolSize: 13,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#000",
                    },
                  },
                ],
              },
            ]
          : []),
      ]}
    />
  );
};

export default VmoPie;

VmoPie.propTypes = {
  data: PropTypes.array,
  CenteredMetric: PropTypes.func,
  color: PropTypes.any,
  margin: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
  }),
  full: PropTypes.bool,
  enableArcLinkLabels: PropTypes.bool,
  enableArcLabels: PropTypes.bool,
  showLegends: PropTypes.bool,
  arcLinkLabelsSkipAngle: PropTypes.number,
  legends: PropTypes.shape({
    anchor: PropTypes.string,
    direction: PropTypes.string,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
    itemsSpacing: PropTypes.number,
    itemWidth: PropTypes.number,
    itemHeight: PropTypes.number,
    itemDirection: PropTypes.string,
  }),
};

VmoPie.defaultProps = {
  data: [],
  CenteredMetric: () => null,
  color: { scheme: "nivo" },
  margin: {
    top: 5,
    right: 80,
    bottom: 80,
    left: 80,
  },
  full: true,
  enableArcLinkLabels: true,
  enableArcLabels: true,
  showLegends: true,
  arcLinkLabelsSkipAngle: 10,
  legends: {
    anchor: "right",
    direction: "column",
    translateX: -80,
    translateY: 0,
    itemsSpacing: 7,
    itemWidth: 101,
    itemHeight: 19,
    itemDirection: "left-to-right",
  },
};
